import { render } from "./FundDeductionModal.vue?vue&type=template&id=455f268b&scoped=true"
import script from "./FundDeductionModal.vue?vue&type=script&lang=js"
export * from "./FundDeductionModal.vue?vue&type=script&lang=js"

import "./FundDeductionModal.vue?vue&type=style&index=0&id=455f268b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f268b"]])

export default __exports__